export enum ACountry {
  Australia = "au",
  NewZealand = "nz",
  Singapore = "sg",
}

export type Countries = ACountry;

export type Country = `${Countries}`;

export type MagentoCountryCodeEnum = Uppercase<Countries>;
